<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />
    <b-container fluid>
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Reporte ARPU</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>RP_Arpu</div>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col>
          <b-row align-v="center" align-h="end" v-if="false">
            <b-col>
              <b-form-group align="left">
                <label for="clinica">Clínicas</label>
                <v-select
                  v-if="!todas"
                  name="clinica"
                  placeholder="Clinicas"
                  label="strNombre"
                  multiple
                  :reduce="(variable) => variable.idClinica"
                  :options="clinicas"
                  v-model="filtro.idClinicas"
                ></v-select>
                <br />
                <b-form-checkbox
                  id="checkbox-1"
                  v-model="todas"
                  name="checkbox-1"
                  @change="todos()"
                >
                  Todas las clínicas
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>

            <b-form-group align="left">
              <label>Fecha de inicio</label>
              <date-picker v-model="$v.filtro.anio.$model" type="year" placeholder="Selecciona un año"
                           :disabled-time="deshabilitarFechas"></date-picker>
            </b-form-group>

          </b-row>
          <b-row>
            <b-col></b-col>
            <b-col></b-col>
            <b-col class="text-right">
              <b-button
                variant="outline-primary"
                :disabled="loader"
                @click="obtenerDatos()"
              >
                <span v-if="!loader">Generar reporte</span>
                <span v-else>
                  <b-spinner small></b-spinner>
                  Buscando...
                </span>
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Header from "../../../components/Header";
import { required } from "vuelidate/lib/validators";
import * as JSZip from "jszip";
import { saveAs } from "file-saver";

export default {
  components: {
    Header,
  },
  name: "ReporteTxPxa",
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      loader: false,
      buscado: false,
      datosTabla: [],
      fields: [],
      registrosPorPagina: 10,
      paginaActual: 0,
      datosTablaDetalle: [],
      registrosPorPaginaDetalle: 10,
      paginaActualDetalle: 0,
      show: false,
      filtro: {
        anio: Number
      },

      clinicas: [],
      todas: false,
      fieldsExcel: "",
      currentPage: 1,
      perPage: 15,
      filter: null,
      filterOn: [],
      totalRows: 1,
    };
  },
  validations: {
    filtro: {
      anio: { required }
    },
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.filtro.anio = new Date();
  },
  methods: {
    obtenerDatos() {
      this.$v.filtro.$touch();

      if (!this.$v.filtro.$invalid) {
        this.loader = true;
        this.buscado = false;
        this.currentPage = 1;
        this.datosTabla = [];

        const startOfMonth = this.$moment(this.filtro.anio).clone().startOf('year').format('YYYY-MM-DD hh:mm');
        //const endOfMonth   = this.$moment(this.filtro.anio).clone().startOf('year').add(2, 'month').format('YYYY-MM-DD hh:mm');
        const endOfMonth   = this.$moment(this.filtro.anio).clone().endOf('year').format('YYYY-MM-DD hh:mm');

        const fechaInicio = this.$moment(startOfMonth);
        let fechaFin = this.$moment(endOfMonth);

        if (this.$moment().year() === this.$moment(this.filtro.anio).year()) {
          fechaFin = this.$moment();
        }


        const envio = {
          idClinicas: [-1],
          fechaInicio: fechaInicio.utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
          fechaFin: fechaFin.add(1, "days").utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
          horas: this.$horas(),
        };

        this.$http
          .post(this.$api + "finanzas/reporte/arpu", envio)
          .then((respuesta) => {
            this.saveXLSX( respuesta.data.data)
          })
          .finally(() => {
            this.loader = false;
            this.buscado = true;
          });
      }

    },
    saveXLSX(datos) {
      const zip = new JSZip();
      zip.file("ARPU.xlsx", datos, { base64: true });
      zip.generateAsync({ type: "blob" }).then(function (content) {
        saveAs(content, "arpu.zip");
      });
    },
    deshabilitarFechas(date) {
      return date > new Date(new Date());
    },
  },
};
</script>

<style scoped>
.adquisicionSpan {
  cursor: pointer;
  text-decoration: underline;
  color: #00458b;
}

.badgeCss {
  display: flex;
  justify-content: flex-end;
}

.badgeTxt {
  padding: 10px;
  font-size: 15px;
  letter-spacing: 1px;
  font-weight: lighter;
}
</style>
